import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Instagram, Mail, MapPin, Facebook } from 'lucide-react';
const FOOTER_BG = '#3D4A2F';
const FOOTER_BG_DARK = '#33402A';
export function SiteFooter() {
  return <footer className="pt-8 pb-5 text-[#E8E4D8]" style={{
    backgroundColor: FOOTER_BG
  }} data-id="element-2573">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-2574">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-6" data-id="element-2575">
          {/* Brand Col */}
          <div className="md:col-span-3" data-id="element-2576">
            <Link to="/" className="inline-flex items-center gap-3 mb-5" data-id="element-2577">
              <img src="https://cdn.magicpatterns.com/uploads/4gduygJNEAxYz3SyjoFAYx/ChatGPT_Image_May_13,_2026,_09_47_03_PM.png" alt="Structured Nutrition" className="w-14 h-14 object-contain" data-id="element-2578" />
              <div className="flex flex-col leading-tight" data-id="element-2579">
                <span className="text-base font-serif text-white tracking-wide" data-id="element-2580">
                  Structured
                </span>
                <span className="text-[10px] font-bold text-[#C8C4B0] uppercase tracking-[0.25em]" data-id="element-2581">
                  Nutrition
                </span>
              </div>
            </Link>
            <p className="text-sm text-[#C8C4B0] leading-relaxed max-w-xs mb-6" data-id="element-2582">
              Evidence-based nutrition coaching for real, sustainable health.
            </p>
            <div className="flex items-center gap-4" data-id="element-2583">
              <a href="#" aria-label="Facebook" className="text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2584">
                <Facebook className="w-5 h-5" data-id="element-2585" />
              </a>
              <a href="#" aria-label="Instagram" className="text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2586">
                <Instagram className="w-5 h-5" data-id="element-2587" />
              </a>
              <a href="mailto:jack@jackachenbach.com" aria-label="Email" className="text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2588">
                <Mail className="w-5 h-5" data-id="element-2589" />
              </a>
            </div>
          </div>

          {/* Quick Links Col */}
          <div className="md:col-span-3" data-id="element-2590">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-3" data-id="element-2591">
              Quick Links
            </h4>
            <ul className="space-y-0.5" data-id="element-2592">
              {[{
              name: 'About',
              path: '/about'
            }, {
              name: 'Services',
              path: '/services'
            }, {
              name: 'Training',
              path: '/training'
            }, {
              name: 'Books',
              path: '/books'
            }, {
              name: 'Shop',
              path: '/shop'
            }, {
              name: 'Contact',
              path: '/contact'
            }].map(link => <li key={link.name} data-id="element-2593">
                  <Link to={link.path} className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2594">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services Col */}
          <div className="md:col-span-3" data-id="element-2595">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-3" data-id="element-2596">
              Services
            </h4>
            <ul className="space-y-0.5" data-id="element-2597">
              <li data-id="element-2598">
                <Link to="/services" className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2599">
                  1:1 GLP-1 Coaching
                </Link>
              </li>
              <li data-id="element-2600">
                <Link to="/services" className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2601">
                  Body Composition
                </Link>
              </li>
              <li data-id="element-2602">
                <Link to="/services" className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2603">
                  Off-Medication Strategy
                </Link>
              </li>
              <li data-id="element-2604">
                <Link to="/training" className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2605">
                  Training App
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div className="md:col-span-3" data-id="element-2606">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-5" data-id="element-2607">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-2608">
              <li className="flex items-start gap-3" data-id="element-2609">
                <MapPin className="w-4 h-4 text-[#C8C4B0] mt-0.5 shrink-0" data-id="element-2610" />
                <span className="text-sm text-[#C8C4B0] leading-relaxed" data-id="element-2611">
                  Available nationwide
                  <br data-id="element-2612" />
                  Virtual coaching
                </span>
              </li>
              <li data-id="element-2613">
                <a href="mailto:jack@jackachenbach.com" className="flex items-center gap-3 text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2614">
                  <Mail className="w-4 h-4 shrink-0" data-id="element-2615" />
                  jack@jackachenbach.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-5 flex flex-col md:flex-row items-center justify-between gap-4" style={{
        borderColor: FOOTER_BG_DARK
      }} data-id="element-2616">
          <p className="text-xs text-[#A8A492]" data-id="element-2617">
            © {new Date().getFullYear()} Jack Achenbach, MS, RDN, CPT. All
            rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-[#A8A492]" data-id="element-2618">
            <Link to="#" className="hover:text-white transition-colors" data-id="element-2619">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-white transition-colors" data-id="element-2620">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}